import type { Response } from '~/types/api/v2'

import { useFetchWithDefaults } from '~/composables/api/useFetchWithDefaults'

import { type DocumentMutationParams, getUrlById as getDocumentByIdUrl } from '../useFetchDocument'

export const useFetchDocumentType = () => {
  const getUrl = (documentId: string) => `${getDocumentByIdUrl(documentId)}/document-types`

  const { put } = useFetchWithDefaults()

  type UpdateDocumentTypesPayload = App.Data.Payloads.Documents.UpdateDocumentTypesPayload

  const update = ({
    payload,
    documentId,
    workspaceId,
  }: DocumentMutationParams<UpdateDocumentTypesPayload>) =>
    put<Response<App.Data.Document.Metadata.DocumentTypeData[]>>({
      url: getUrl(documentId),
      workspaceId,
      fetchOptions: {
        body: payload,
        query: { include: ['translations'] },
      },
    })

  return {
    update,
  }
}
